import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { Box, TextField } from '@mui/material';

import { Button, IconButton, ClearIcon, SearchIcon, TuneIcon } from '@occc-app/design-system';
export interface ISearchProps {
  onChange: (arg?: any) => void;
  value: any;
  hasFilters?: boolean;
  showFilters?: boolean;
  toggleFilters?: () => void;
}

class Search extends React.Component<ISearchProps, {}> {
  state: { value: string } = {
    value: '',
  };

  // This component manages its input value in component state
  // because `this.props.onChange` is wrapped by `PageableRequest.tsx`
  // to also fetch records. Refactoring this to work with Redux state,
  // like we'd expect, is a much larger chunk of work than we're willing to
  // commit to at this point in time.
  onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.currentTarget.value;
    this.setState({ value });
  };

  onEnter = (ev: React.KeyboardEvent<HTMLInputElement>) => {
    if (ev.which === 13) {
      ev.currentTarget.value = this.state.value;
      this.props.onChange(ev);
    }
  };

  onSubmit = (ev: React.FormEvent<HTMLButtonElement>) => {
    ev.currentTarget.value = this.state.value;
    this.props.onChange(ev);
  };

  onClear = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.currentTarget.value = '';
    this.setState({ value: '' });
    this.props.onChange(ev);
  };

  renderFilterButton = () => {
    if (!this.props.hasFilters) {
      return;
    }
    const filterText = this.props.showFilters ? 'Hide Filters' : 'Show Filters';
    return (
      <Button
        variant='contained'
        startIcon={<TuneIcon />}
        onClick={this.props.toggleFilters}
        sx={{
          mr: 2,
          flexShrink: 0,
        }}
      >
        {filterText}
      </Button>
    );
  };

  renderInputAdornment = () => {
    const clearButton = (
      <IconButton onClick={this.onClear} size='small'>
        <ClearIcon />
      </IconButton>
    );

    return (
      <InputAdornment position='end'>
        {this.state.value && clearButton}
        <IconButton onClick={this.onSubmit} size='small'>
          <SearchIcon />
        </IconButton>
      </InputAdornment>
    );
  };

  render() {
    return (
      <Box display='flex'>
        {this.renderFilterButton()}
        <TextField
          variant='outlined'
          placeholder='Search...'
          onChange={this.onChange}
          onKeyPress={this.onEnter}
          value={this.state.value}
          margin='none'
          fullWidth={true}
          InputProps={{ endAdornment: this.renderInputAdornment() }}
        />
      </Box>
    );
  }
}

export default Search;
